var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19368_8999)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#B1D7F6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19368_8999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2 33.425L38.425 30.1625L36.325 28.025L34.675 29.675L32.575 27.575L34.1875 25.925L32.5 24.2375L29.2375 27.5L35.2 33.425ZM47.5 45.7625L50.7625 42.5L49.075 40.8125L47.425 42.425L45.325 40.325L46.9375 38.675L44.8 36.575L41.575 39.8L47.5 45.7625ZM32.875 48.5H26.5V42.125L33.0625 35.5625L25 27.5L32.5 20L40.6 28.1L46.2625 22.4C46.5625 22.1 46.9 21.875 47.275 21.725C47.65 21.575 48.0375 21.5 48.4375 21.5C48.8375 21.5 49.225 21.575 49.6 21.725C49.975 21.875 50.3125 22.1 50.6125 22.4L52.6 24.425C52.9 24.725 53.125 25.0625 53.275 25.4375C53.425 25.8125 53.5 26.2 53.5 26.6C53.5 27 53.425 27.3815 53.275 27.7445C53.125 28.1075 52.9 28.4385 52.6 28.7375L46.9375 34.4375L55 42.5L47.5 50L39.4375 41.9375L32.875 48.5ZM29.5 45.5H31.6L46.3 30.8375L44.1625 28.7L29.5 43.4V45.5ZM45.25 29.7875L44.1625 28.7L46.3 30.8375L45.25 29.7875Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19368_8999",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_19368_8999"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19368_8999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19368_8999",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19368_8999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(26 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/design-icon.790dad5e2812fe682b5e3af3fe60e3e0.svg";
export { ForwardRef as ReactComponent };